import {
  Autocomplete,
  TextField,
} from '@xbotvn/mui';
import PropTypes from 'prop-types';
import React from 'react';

import {
  find,
} from '../libs/lodash';

export default function SingleSelect({
  options,
  value,
  onChange,
  placeholder,
  disabled,
  InputProps,
  clearable,
}) {
  const getActiveValue = () => find((option) => option.value === value)(options) || [];

  return (
    <Autocomplete
      disabled={disabled}
      getOptionLabel={(option) => option?.label || ''}
      isOptionEqualToValue={(option) => option.value === value}
      value={getActiveValue()}
      options={options}
      noOptionsText={placeholder}
      onChange={(e, data) => onChange(data?.value || '')}
      renderInput={(params) => <TextField placeholder={placeholder} {...InputProps} {...params} />}
      fullWidth
      disableClearable={!clearable}
    />
  );
}

SingleSelect.defaultProps = {
  options: [],
  value: undefined,
  onChange: () => { },
  placeholder: 'Select option',
  disabled: false,
  InputProps: {},
  clearable: false,
};

SingleSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
    label: PropTypes.string.isRequired,
    rightLabel: PropTypes.string,
  })),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  InputProps: PropTypes.shape({}),
  clearable: PropTypes.bool,
};
